import React,{useEffect} from "react";
import { Switch, Route } from "react-router-dom";
import Layout from "./Layout/Layout";
import CreateRoom from './Container/CreateRoom';
import Room from './Container/Room';
import Home from './Container/Home';
import MeetingInfoProvider from './Context/ChatContext';
import ConfigProvider from './Context/ConfigContext';

function App(props) {
  useEffect(() => {
    let disableConfirmation = false;
    window.addEventListener('beforeunload', event => {
      const confirmationText = 'Are you sure?';
      if (!disableConfirmation) {
        event.returnValue = confirmationText; // Gecko, Trident, Chrome 34+
        return confirmationText;              // Gecko, WebKit, Chrome <34
      } else {
        // Set flag back to false, just in case
        // user stops loading page after clicking a link.
        disableConfirmation = false;
      }
    });
  },[])
  return (
    <MeetingInfoProvider>
      <ConfigProvider>
        <Layout>
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/huddle-setup' render={() => <div>Call Setup Page</div>} />
            <Route path='/create-room' component={CreateRoom} />
            <Route path='/room/:room' component={Room} />
          </Switch>
        </Layout>
      </ConfigProvider>
    </MeetingInfoProvider>
  );
}

export default App;
